import React from 'react';

import {
  Datagrid,
  DateField,
  ReferenceField,
  ChipField,
  TextField,
  usePermissions,
} from 'react-admin';

import ReferenceEntityField from '../../../../customFields/ReferenceEntityField';
import { boldDataGridStyle } from '../../../../constants/style/datagridStyles';
import NoResults from '../../../layout/NoResults';
import StatusField from '../../../../customFields/StatusField';
import LinkField from '../../../layout/LinkField';
import EntityDisplayNameField from '../../../../customFields/EntityDisplayNameField';
import actions, { Actions } from '../../../../constants/actions';
import hasAccess from '../../../../utilities/hasAccess';

const Kyc = (
  {
    children,
  }: {

    children?: React.ReactNode;
  },
) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid sx={boldDataGridStyle} bulkActionButtons={false} empty={<NoResults variant="h6" />}>
      <LinkField sortable={false} source="id" label="ID" />
      <TextField sortable={false} source="customId" label="Custom ID" />
      <DateField sortable source="createdAt" showTime />
      <StatusField sortable={false} source="recommendation" />
      {hasAccess(permissions, actions.PROCESS_GET) && (
        <ReferenceField sortable reference="processes" source="process">
          <ChipField source="name" />
        </ReferenceField>
      )}
      <ReferenceEntityField sortable={false} source="extraInformation.entity" label="Entity">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      {children}
    </Datagrid>
  );
};

export default Kyc;
